import * as React from 'react';
import { Typography } from '@material-ui/core';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { observer } from 'mobx-react';

export interface TitleMessageProps {
  message?: string,
  title?: string
}
type LocalStyles = 'root';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing.unit * 4,
  },
});


type PropsWithStyle = WithStyles<LocalStyles> & TitleMessageProps;

@observer
class TitleMessagePage extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    return (
      <Paper elevation={1} className={this.props.classes.root}>
        {
          this.props.title &&
            <>
            <Typography variant="h4">
              {this.props.title}
            </Typography>
            <br/>
            </>
        }
        {
          this.props.message &&
          <Typography variant="body1">
            {this.props.message}
          </Typography>
        }
      </Paper>
    );
  }
}

export default withStyles(localStyles)(TitleMessagePage);
